import { Banner, CTA } from '@/components'
import mailer from '../assets/images/contactUs.png'
import { Fade, JackInTheBox, Slide } from "react-awesome-reveal";
import { Helmet } from 'react-helmet-async';
import { useState } from 'react';

import emailjs from "emailjs-com";

export const Contact = () => {

    const [formData, setFormData] = useState({
        name: "",
        subject: "",
        email: "",
        message: "",
    });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setError("");

        // EmailJS configuration
        const serviceID = "service_hbu7u4o";
        const templateID = "template_ve1jhlr";
        const publicKey = "3nT41gX2gJNVdCvSM";
        setIsSubmitted(false);
        if(formData.email=='' || formData?.message=='' || formData?.subject=='' || formData?.name=='') {
            setError("Make sure to fill in all the fields")
            return
        }
        emailjs
            .send(serviceID, templateID, formData, publicKey)
            .then(
                (response) => {
                    console.log("SUCCESS!", response.status, response.text);
                    setIsSubmitted(true);
                    setTimeout(()=>{
                        setIsSubmitted(false)
                    },2000)
                    setFormData({ name: "", email: "", subject: "", message: "" });
                },
                (err) => {
                    console.error("FAILED...", err);
                    setError("Failed to send the message. Please try again.");
                }
            );
    };

    return (
        <>

            <Helmet>
                <title>Morse Code Academy | Contact</title>
                <meta name="title" content="Morse Code Academy | Contact" />
                <meta
                    name="description"
                    content="Morse Code Academy is an Educational Application, that teaches users The Morse Code in any language they prefer, and prepares them through several practices before rewarding them with a certificate."
                />
                <meta
                    property="og:description"
                    content="Morse Code Academy is an Educational Application, that teaches users The Morse Code in any language they prefer, and prepares them through several practices before rewarding them with a certificate."
                />
                <meta property="og:image" content={mailer} />
                <meta
                    property="og:title"
                    content="Morse Code Academy"
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://morsecodeacademy.site/contact" />
            </Helmet>

            <JackInTheBox triggerOnce={true} delay={1000}>
                <Banner
                    subtitle={".-. . .- -.-. .... / --- ..- -"}
                    title={'REACH <span class="stroke white">OUT </span>'}
                    image={mailer}
                />
            </JackInTheBox>
            <div className=" contact-crev ">
                <div className="py-100 container mh-100v align-items-center d-flex ">
                    <div className="row justify-content-center ">
                        <div className="col-lg-4">
                            <Slide triggerOnce={true} delay={300}>
                                <h2 className="fs-50 text-white mt-3">Get In Touch</h2>
                            </Slide>
                            <h5 className='text-white  fw-700 mt-2'>Follow us</h5>
                            <div className="d-flex align-items-center mt-2 flex-wrap ">
                                {/* <Fade triggerOnce={true} delay={200}>
                                    <a className="theme-btn btn-outline white circular-social-icon  mt-2 mr-2" target='_blank'>
                                        <i className="fa-brands fa-facebook-f"></i>
                                    </a>
                                </Fade> */}
                                <Fade triggerOnce={true} delay={300}>
                                    <a href='https://www.instagram.com/morsecodeacademy/' className="theme-btn btn-outline white circular-social-icon  mt-2 mr-2" target='_blank'>
                                        <i className="fa-brands fa-instagram"></i>
                                    </a>
                                </Fade>
                                {/* <Fade triggerOnce={true} delay={400}>
                                    <a className="theme-btn btn-outline white circular-social-icon  mt-2 mr-2" target='_blank'>
                                        <i className="fa-brands fa-x-twitter"></i>
                                    </a>
                                </Fade>
                                <Fade triggerOnce={true} delay={500}>
                                    <a className="theme-btn btn-outline white circular-social-icon  mt-2 mr-2" target='_blank'>
                                        <i className="fa-brands fa-tiktok"></i>
                                    </a>
                                </Fade>
                                <Fade triggerOnce={true} delay={600}>
                                    <a className="theme-btn btn-outline white circular-social-icon  mt-2 mr-2" target='_blank'>
                                        <i className="fa-brands fa-linkedin-in"></i>
                                    </a>
                                </Fade> */}
                            </div>

                        </div>
                        {/*<div className="col-lg-6 d-none">
                             <div className='py-3'>
                                <Fade triggerOnce={true}>
                                    <div className="d-flex align-items-center  mt-2">
                                        <a className="theme-btn btn-outline white circular-social-icon mr-md-3 mr-2" target='_blank'>
                                            <i className="fa-solid fa-location-dot"></i>
                                        </a>
                                        <div className=' text-white fs-16'>Beirut, Lebanon</div>
                                    </div>
                                </Fade>
                                <Fade triggerOnce={true} delay={200}>
                                    <div className="d-flex align-items-center mt-2 ">
                                        <a className="theme-btn btn-outline white circular-social-icon mr-md-3 mr-2" target='_blank'>
                                            <i className="fa-solid fa-phone fs-16"></i>
                                        </a>
                                        <a href="tel:+96171032898" target='_blank' className=' text-white fs-16'>+961 71 032 898</a>
                                    </div>
                                </Fade>
                                <Fade triggerOnce={true} delay={400}>
                                    <div className="d-flex align-items-center mt-2 ">
                                        <a className="theme-btn btn-outline white circular-social-icon mr-md-3 mr-2" target='_blank'>
                                            <i className="fa-regular fa-envelope"></i>
                                        </a>
                                        <a href="mailto:seroujkh.dev@gmail.com" target='_blank' className=' text-white fs-16 '>seroujkh.dev@gmail.com</a>
                                    </div>
                                </Fade>
                            </div> 
                        </div>*/}

                        <div className="col-lg-6 mt-lg-0 mt-3">
                            <form action="
                        "  onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-6  mt-3">
                                        <Fade triggerOnce={true}>
                                            <input type="text" name='name' placeholder='Name' onChange={handleChange} value={formData.name} />
                                        </Fade>
                                    </div>
                                    <div className="col-lg-6  mt-3">
                                        <Fade triggerOnce={true} delay={200}>
                                            <input type="text" name='email' placeholder='Email' onChange={handleChange} value={formData.email} />
                                        </Fade>
                                    </div>
                                    <div className="col-lg-12 mt-3">
                                        <Fade triggerOnce={true} delay={300}>
                                            <input type="text" name='subject' placeholder='Subject' onChange={handleChange} value={formData.subject} />
                                        </Fade>

                                    </div>

                                    <div className="col-lg-12 mt-3">
                                        <Fade triggerOnce={true} delay={400}>
                                            <textarea name='message' placeholder='Message' onChange={handleChange} value={formData.message} />
                                        </Fade>
                                    </div>

                                    <div className="mt-3 col-lg-12">
                                    <span className='text-red ' style={{color:'red'}}>{error}</span>
                                    {isSubmitted && <span className='text-green ' style={{color:'green'}}>Message sent, we will reach out soon</span>}
                                        <Fade triggerOnce={true} delay={600}>
                                            <button type="submit" className="mt-3 theme-btn btn-outline circular white w-auto d-flex" ><span className='fs-16'>Let's Talk</span></button>
                                        </Fade>
                                    </div>
                                </div>


                            </form>
                        </div>
                    </div>
                </div>

            </div >

            <CTA />
        </>
    )
}